import React, { Fragment } from 'react';

const VehicleInUse = ({ city = 'toronto' }) => (
  <Fragment>
    {city === 'new_york' ? (
      <Fragment>
        <p>
          Please call us at&nbsp;
          <a className="faq__panel--link" href="tel:+18336928898">
            1-833-692-8898
          </a>
          &nbsp;and we will assist you.
        </p>
      </Fragment>
    ) : (
      <Fragment>
        <p>
          Please call us at&nbsp;
          <a className="faq__panel--link" href="tel:+18336928898">
            1-833-692-8898
          </a>
          &nbsp;and we will find out who is still online with the vehicle plate.
        </p>
        <b>$15 fee is applied for incorrect plate use which is then credited in full to the affected driver.</b>
        <br />
        <br />
        <b>Remember to:</b>
        <ol>
          <li> Select the correct vehicle plate in the Uber Driver App at the start of your booking; AND,</li>
          <li> Go offline at the end of your booking.</li>
        </ol>
        <br />
        <b>Otherwise, being on the wrong plate results in the following:</b>
        <ul>
          <li> It might block another driver from using the same plate;</li>
          <li> You will not be covered under insurance; and</li>
          <li> Riders will not be able to identify you for pickup and you may be banned from Uber.</li>
        </ul>
      </Fragment>
    )}
  </Fragment>
);

export default VehicleInUse;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/VehicleInUse.js